import React from 'react';
import { Button } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';

const Btn = (props) => {
  const { t } = props;
  const tkey = 'public:event_buttons.' + props.tkey;
  
  return(
    props.show &&
      <Button
        className='rtxEventButton'
        compact
        basic
        color='red'
        /* inverted={props.inverted} */
        disabled={!props.show}
        icon={props.icon}
        content={t(tkey)}
        path={props.path}
        onClick={props.onClick}
      />
  );
};

export default withNamespaces('public')(Btn);



// WEBPACK FOOTER //
// ./src/public/components/EventsList/Event/Button.js